import { post, put } from "@/api";

export interface BackApplySpecItem {
  goods_id: number | string;
  spec_id: number | string;
  quantity: number;
}

export interface BackApplyParams {
  order_id: number | string;
  /** 退货 / 换货 */
  type: "退货" | "换货";
  specs: BackApplySpecItem[];
  reason?: string;
  remark?: string;
  images?: string[];
}

export interface BackApplyResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  errors?: Record<string, string[]>;
}

/** 提交售后申请 */
export function applyBack(params: BackApplyParams) {
  return put<BackApplyResponse>("/platform/back/apply", params);
}

/** 售后类型 */
export type BackType = "退货" | "换货";

/** 售后状态 */
export type BackState = "申请中" | "已确认" | "已拒绝" | "已完成";

export interface BackOffice {
  id?: number | string;
  title?: string;
  [key: string]: unknown;
}

export interface BackGoods {
  id?: number | string;
  title?: string;
  m_pic?: string;
  [key: string]: unknown;
}

export interface BackRecord {
  id: number | string;
  back_sn?: string;
  order_id?: number | string;
  order_sn?: string;
  department_id?: number | string;
  account_id?: number | string;
  account_name?: string;
  goods_id?: number | string;
  spec_id?: number | string;
  sku?: string;
  goods_name?: string;
  sku_name?: string;
  unit?: string;
  price?: number | string;
  quantity?: number | string;
  amount?: number | string;
  type?: BackType | string;
  state?: BackState | string;
  reason?: string | null;
  remark?: string | null;
  /** 拒绝/处理意见 */
  back_remark?: string | null;
  images?: string[] | null;
  check_time?: string | null;
  /** 退换货时间 */
  change_time?: string | null;
  complete_time?: string | null;
  created_at?: string;
  updated_at?: string;
  office?: BackOffice | null;
  goods?: BackGoods | null;
  [key: string]: unknown;
}

export interface BackPagesParams {
  page?: number;
  pagenumber?: number;
  search?: string;
  /** 售后状态 */
  state?: BackState | BackState[] | string | string[];
  /** 售后类型：退货 / 换货 */
  type?: BackType | BackType[] | string | string[];
  date_range?: string[];
}

export interface BackPagesResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: BackRecord[];
  total?: number;
  page?: number;
  pagenumber?: number;
}

/** 当前账号售后申请分页列表 */
export function getBackPages(params: BackPagesParams = {}) {
  return post<BackPagesResponse>("/platform/back/pages", params);
}
